import { isolateComponent } from '@zapier/style-encapsulation';
import { daysFromNow } from '@zapier/date';
import { Alert, Link } from '@zapier/design-system';
import { Price } from '@zapier/currency';
import { buildUpgradeUrl, getShouldRenderSunsetCopy } from './utils';
import { Fragment } from 'react';
export const shouldRender = (data) => {
    const { isTrialing, trialEndDate } = data.currentAccount;
    return !!isTrialing && !!trialEndDate;
};
export const Component = function ProfessionalTrialing(props) {
    var _a;
    const { data, currency } = props;
    const { currentAccount, nextPlan } = data;
    const { trialEndDate } = currentAccount;
    const trialDaysRemaining = daysFromNow(trialEndDate);
    const daysText = trialDaysRemaining === 1 ? 'day' : 'days';
    const nextPlanAmount = ((nextPlan === null || nextPlan === void 0 ? void 0 : nextPlan.amount) || 0) / 12;
    const upgradeUrl = buildUpgradeUrl({
        currentPlanName: currentAccount.plan.name,
        upgradePlanName: (_a = data.nextPlan) === null || _a === void 0 ? void 0 : _a.name,
        interval: currentAccount.plan.interval,
    });
    const onClickLink = () => {
        props.trackEvent('Trial: clicked banner');
    };
    const shouldRenderCopy = getShouldRenderSunsetCopy(currentAccount.campaignOffers);
    const offer = shouldRenderCopy && currentAccount.campaignOffers[0];
    return (isolateComponent(Alert, { layout: props.layout, title: "Welcome to your Professional trial!", type: "info" },
        isolateComponent("p", null,
            `You have ${trialDaysRemaining} ${daysText} to try Zapier’s `,
            isolateComponent(Link, { href: "/help/account/billing-pricing/understand-your-zapier-premium-trial", onClick: onClickLink }, "paid features"),
            ".",
            ' ',
            offer ? (isolateComponent(Fragment, null,
                isolateComponent(Link, { href: "/app/billing/plans" }, "Upgrade"),
                " before November 14th, 2022 and get a free year of Zapier.")) : (isolateComponent(Fragment, null,
                isolateComponent(Link, { href: upgradeUrl, onClick: onClickLink }, "Upgrade"),
                ' ',
                "anytime",
                nextPlanAmount > 0 && (isolateComponent("span", null,
                    ' ',
                    "for as low as",
                    ' ',
                    isolateComponent(Price, { currency: currency }, nextPlanAmount),
                    "/month.")))))));
};
//# sourceMappingURL=ProfessionalTrialing.js.map
// @zapier/universal-layout@5.12.61 (4902ab0c1)
